import { FunctionComponent } from 'preact';
import { ReadMore } from './readMore/readMore';
import { videoDataSelector } from '../../common/store/selectors/videoData.selector';
import { useState, useEffect } from 'preact/hooks';
import { isEmpty, isEmptyObject } from '../../common/utils/utils';
import { useSelector } from 'react-redux';

const REGEX = /\d+/;
const TIME_SEGMENTS_INDEX = 0;

const extractTimeSegmentFromKeyValue = (customParam: Array<any>): Array<any> => {
  const key = customParam[0];
  const endOfScene = key.match(REGEX);
  if (endOfScene) {
    return [
      parseInt(endOfScene.toString(), 10),
      customParam[1],
    ];
  }
  return [];
};

const ReadMorePlugin: FunctionComponent = () => {
  const customParams = useSelector(videoDataSelector.customParams);

  const [sortedCustomParams, setSortedCustomParams] = useState([]);

  useEffect(() => {
    if (!isEmptyObject(customParams)) {
      const formattedList: Array<any> = Object.entries(customParams).map(extractTimeSegmentFromKeyValue);
      const filteredNewList = formattedList.filter(customParam => !isEmpty(customParam));
      setSortedCustomParams(filteredNewList.sort((a, b) => a[TIME_SEGMENTS_INDEX] - b[TIME_SEGMENTS_INDEX]));
    } else {
      setSortedCustomParams([]);
    }
  }, [customParams]);

  return (<ReadMore sortedCustomParams={sortedCustomParams} />)
};

export default ReadMorePlugin;
